import(/* webpackMode: "eager" */ "/vercel/path0/src/app/categories/bedroom/page.js");
